import React from "react";

const popup404 = (
  <div className="text-white m-5 text-center">
    <h1 className="">Oops!</h1>
    <p className="">Looks like you are looking for a page that doesn't exist.</p>
    <p className="">Please visit the <strong>Homepage </strong>or use the <strong>Contact</strong> button to drop me an email.</p>
  </div>
);

class Page404 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTourActive: false,
    };
  };
  render() {
    return (
      popup404
    )
  }
  

}

export default Page404;